import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "@stream-io/video-react-sdk/dist/css/styles.css";

import "./assets/css/Main.css";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { AuthProvider } from "./hooks/context/Context";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>
);
